import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=a637387a&scoped=true&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"
import style0 from "./manager.vue?vue&type=style&index=0&id=a637387a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a637387a",
  null
  
)

export default component.exports